import { Component } from '@angular/core';

@Component({
  selector: 'app-approve-validation',
  templateUrl: './approve-validation.component.html',
  styleUrls: ['./approve-validation.component.css'],
})
export class ApproveValidationComponent {
  title1 = 'Admin Panel';
  title = 'Approved Business';
  class1 = 'profile-banner ';
  img1 = '../../../assets/images/logo.png';
}
